import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { util, isElectron as forElectron, apiHolder, getOs } from 'api';
import classnames from 'classnames';
import { navigate } from 'gatsby';
import styles from './index.module.scss';
import { ReactComponent as DeleteIcon } from '@/images/icons/setting/keyboard_delete.svg';
import SiriusModel from '@web-common/components/UI/Modal/SiriusModal';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
import CustomEditKey from './CustomEditKey';
import { useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import { HotKeysType, validateMailHK, validateGlobalHK, actions as hkActions } from '@web-common/state/reducer/hotkeysReducer';
import { formatHotKey2SettingPage } from '@web-common/utils/hotkey';
const { config } = require('env_def');
const systemApi = apiHolder.api.getSystemApi();
const isWebWmEntry = systemApi.isWebWmEntry();
const dataStoreApi = apiHolder.api.getDataStoreApi();
const nimApi = apiHolder.api.requireLogicalApi('NIM');
const isElectron = forElectron();
const isMac = getOs() === 'mac';
const shift = 'Shift';
const enter = '↵';
const up = '↑';
const down = '↓';
const mouseLeft = getIn18Text('ZUOJIAN');
const del = React.createElement(DeleteIcon, null);
const separator = ' ';
const getLocalHotKey = (localData, hkMap) => {
    return localData.map(item => {
        const hotKeyStr = hkMap[item.key] ? formatHotKey2SettingPage(hkMap[item.key]) : item.content;
        if (!item.hotKeyStr && hotKeyStr) {
            return Object.assign(Object.assign({}, item), { hotKeyStr, hotKey: hkMap[item.key] });
        }
        return item;
    });
};
export const Keyboard = ({ noBorder, left = 16, isModel }) => {
    const [enableIM, setEnableIM] = useState(false);
    const [sendMailhk, setSendMailhk] = useState(() => {
        try {
            return !!localStorage.getItem('MAIL_WRITE_HOTKEY_LOCAL_KEY');
        }
        catch (e) {
            console.error('[error] sendMailhk', e);
        }
        return false;
    });
    const globalHotKeysMap = useAppSelector(state => state.hotKeyReducer.globalHotKeysMap);
    const mailHotKeysMap = useAppSelector(state => state.hotKeyReducer.mailHotKeysMap);
    const command = util.getCommonTxt();
    const dispatch = useAppDispatch();
    const validateGlobalHotKey = useCallback((value) => {
        if (value == null || value.length == 0) {
            return Promise.resolve(true);
        }
        else {
            return dispatch(validateGlobalHK(value)).unwrap();
        }
    }, []);
    const validateMailHotKey = useCallback((value) => {
        if (value == null || value.length == 0) {
            return Promise.resolve(true);
        }
        else {
            return dispatch(validateMailHK(value)).unwrap();
        }
    }, []);
    const handleUpdateHk = (key, value) => {
        dispatch(hkActions.doUpdateHotKeysMap({ key, value }));
    };
    const globalList = useMemo(() => {
        let list = [
            {
                name: getIn18Text('CHAKANQUANBUKUAI'),
                key: HotKeysType.CHAKANQUANBUKUAI,
            },
            {
                key: HotKeysType.YINCANG,
                name: isMac ? getIn18Text('YINCANGZHICHENGXUW') : getIn18Text('YINCANGZHITUOPAN'),
                filterKey: command + 'W',
                show: isElectron,
            },
            {
                name: getIn18Text('ZUIXIAOHUA/HUIFKHD'),
                key: HotKeysType.MINMIZE,
                validate: validateGlobalHotKey,
                edit: true,
                show: isElectron,
            },
            {
                name: getIn18Text('QUANXUAN'),
                key: HotKeysType.QUANXUAN,
                filterKey: command + 'A',
                show: false,
            },
            {
                name: getIn18Text('JIETU'),
                key: HotKeysType.CAPTURESCREEN,
                validate: validateGlobalHotKey,
                edit: true,
                show: isElectron,
            },
            {
                name: getIn18Text('FANGDATUPIAN'),
                key: HotKeysType.FANGDATUPIAN,
                filterKey: command + '+',
                show: isElectron,
            },
            {
                name: getIn18Text('FANGXIAOTUPIAN'),
                key: HotKeysType.FANGXIAOTUPIAN,
                filterKey: command + '-',
                show: isElectron,
            },
            {
                name: getIn18Text('BAOCUNTUPIAN'),
                key: HotKeysType.BAOCUNTUPIAN,
                filterKey: command + 'S',
                show: isElectron,
            },
            {
                name: getIn18Text('DAKAISHEZHI'),
                key: HotKeysType.DAKAISHEZHI,
                filterKey: command + '0',
                show: isElectron,
            },
            {
                name: getIn18Text('DAKAIYOUXIANG'),
                key: HotKeysType.DAKAIYOUXIANG,
                filterKey: command + '1',
                show: isElectron,
            },
            {
                name: getIn18Text('DAKAIXIAOXI'),
                key: HotKeysType.DAKAIXIAOXI,
                filterKey: command + '2',
                show: isElectron,
            },
            {
                name: getIn18Text('DAKAIRILI'),
                key: HotKeysType.DAKAIRILI,
                filterKey: command + '3',
                show: isElectron,
            },
            {
                name: getIn18Text('DAKAI\u201CYUNWEN'),
                key: HotKeysType.DAKAIYUNWEN,
                filterKey: command + '4',
                show: isElectron,
            },
            {
                name: getIn18Text('DAKAI\u201CTONGXUN'),
                key: HotKeysType.DAKAITONGXUN,
                filterKey: command + '5',
                show: isElectron,
            },
        ];
        list = getLocalHotKey(list, globalHotKeysMap);
        return list;
    }, [
        globalHotKeysMap,
    ]);
    const mailList = useMemo(() => {
        const data = [
            {
                name: getIn18Text('SOUSUOYOUJIAN'),
                key: HotKeysType.SOUSUOYOUJIAN,
                edit: true,
            },
            {
                name: getIn18Text('XINJIANXIEXIN'),
                key: HotKeysType.XINJIANXIEXIN,
                validate: validateGlobalHotKey,
                edit: true,
            },
            {
                name: getIn18Text('BAOCUNCAOGAO'),
                key: HotKeysType.BAOCUNCAOGAO,
                validate: validateGlobalHotKey,
            },
            {
                name: getIn18Text('FASONGYOUJIAN'),
                key: HotKeysType.FASONGYOUJIAN,
                content: (React.createElement("span", { className: styles.keyboardContentWrap },
                    React.createElement("span", { style: sendMailhk ? {} : { color: '#B7BAC2' } }, command + separator + enter),
                    React.createElement("span", { className: styles.linkTxt, onClick: () => {
                            localStorage.setItem('MAIL_WRITE_HOTKEY_LOCAL_KEY', !sendMailhk ? '1' : '');
                            setSendMailhk(!sendMailhk);
                            message.info(!sendMailhk ? getIn18Text('DAKAICHENGGONG') : getIn18Text('GUANBICHENGGONG'));
                        } },
                        getIn18Text('DIANJI'),
                        sendMailhk ? getIn18Text('GUANBI') : getIn18Text('KAIQI')))),
            },
            {
                name: getIn18Text('SHANCHUYOUJIAN'),
                key: HotKeysType.SHANCHUYOUJIAN,
                edit: true,
            },
            {
                name: getIn18Text('SHANGYIFENGYOUJIAN'),
                key: HotKeysType.SHANGYIFENGYOUJIAN,
            },
            {
                name: getIn18Text('XIAYIFENGYOUJIAN'),
                key: HotKeysType.XIAYIFENGYOUJIAN,
            },
            {
                name: getIn18Text('DUXIN-SHANGYIF'),
                key: HotKeysType.DUXINSHANGYIF,
                edit: true,
            },
            {
                name: getIn18Text('DUXIN-XIAYIF'),
                key: HotKeysType.DUXINXIAYIF,
                edit: true,
            },
            {
                name: getIn18Text('HUIFU'),
                key: HotKeysType.HUIFU,
                edit: true,
            },
            {
                name: getIn18Text('HUIFUQUANBU'),
                key: HotKeysType.HUIFUQUANBU,
                edit: true,
            },
            {
                name: getIn18Text('ZHUANFA'),
                key: HotKeysType.ZHUANFA,
                edit: true,
            },
            {
                name: getIn18Text('BIAOJIYIDU'),
                key: HotKeysType.BIAOJIYIDU,
                edit: true,
            },
            {
                name: getIn18Text('BIAOJIWEIDU'),
                key: HotKeysType.BIAOJIWEIDU,
                edit: true,
            },
            {
                name: getIn18Text('LIEBIAO-DUOXUANYJ'),
                hotKeyStr: command + separator + mouseLeft,
                key: HotKeysType.DUOXUANYOUJIAN,
            },
            {
                name: getIn18Text('LIEBIAO-LIANXUDXYJ'),
                hotKeyStr: shift + separator + mouseLeft,
                key: HotKeysType.LIANXUDUOXUANYOU,
            },
            {
                name: getIn18Text('XUANZHONGYOUJIANXIN'),
                key: HotKeysType.XUANZHONGYOUJIANXIN,
                edit: true,
            },
        ];
        let list = getLocalHotKey(data, mailHotKeysMap);
        return list.map(item => {
            item.validate = validateMailHotKey;
            return item;
        });
    }, [sendMailhk, mailHotKeysMap]);
    const imList = useMemo(() => [
        {
            name: getIn18Text('FAXIAOXI'),
            key: HotKeysType.FAXIAOXI,
            hotKeyStr: enter,
        },
        {
            name: getIn18Text('SHANGYIFENGXIAOXI'),
            key: HotKeysType.SHANGYIFENGXIAOXI,
            hotKeyStr: up,
            show: false,
        },
        {
            name: getIn18Text('XIAYIFENGXIAOXI'),
            key: HotKeysType.XIAYIFENGXIAOXI,
            hotKeyStr: down,
            show: false,
        },
        {
            name: getIn18Text('HUANXING'),
            key: HotKeysType.HUANXING,
            hotKeyStr: shift + separator + enter + getIn18Text('\uFF0CHUOZHE') + command + separator + enter,
        },
        {
            name: getIn18Text('KUAIJIESOUSUO'),
            key: HotKeysType.KUAIJIESOUSUO,
            hotKeyStr: command + separator + 'F',
        },
    ], []);
    const diskList = useMemo(() => [
        {
            name: getIn18Text('KUAIJIESOUSUO'),
            hotKeyStr: command + separator + 'F',
            key: HotKeysType.DISKKUAIJIESOUSUO,
        },
    ], []);
    const keyList = useMemo(() => {
        const list = [
            {
                title: getIn18Text('QUANJU'),
                content: globalList,
            },
            {
                title: getIn18Text('YOUXIANG'),
                content: mailList,
            },
            {
                title: getIn18Text('YUNWENDANG'),
                content: diskList,
            },
        ];
        if (enableIM) {
            list.splice(1, 0, {
                title: getIn18Text('XIAOXI'),
                content: imList,
            });
        }
        return list;
    }, [enableIM, mailList, globalList]);
    useEffect(() => {
        nimApi.getIMAuthConfig() && setEnableIM(true);
    }, []);
    return (React.createElement("div", { className: styles.keyboardWrap }, keyList.map(obj => (React.createElement("div", { className: classnames(styles.keyTable, {
            [styles.noBorder]: noBorder,
        }), key: obj.title },
        React.createElement("div", { style: { paddingLeft: left }, className: styles.keyTitle }, obj.title),
        React.createElement("div", { className: styles.keyContent }, obj.content.map(item => (React.createElement("div", { className: styles.keyRow, hidden: item.show === undefined ? false : !item.show, key: item.name },
            React.createElement("div", { style: { marginLeft: left }, className: styles.label }, item.name),
            React.createElement("div", { className: styles.key }, (item === null || item === void 0 ? void 0 : item.edit) ? (React.createElement(CustomEditKey, { value: item.hotKey, validate: item.validate, onAdd: v => {
                    handleUpdateHk(item.key, v);
                }, onFail: () => {
                    message.error({ content: getIn18Text('YUYIYOUKUAIJIEJCTQCXSR'), key: 1 });
                } })) : (item.content || item.hotKeyStr)))))))))));
};
export const KeyboardModel = ({ visible, onCancel }) => (React.createElement(SiriusModel, { onCancel: onCancel, visible: visible, footer: null, title: getIn18Text('KUAIJIEJIAN'), width: 476, className: styles.keyboardModelWrap },
    React.createElement(Keyboard, { noBorder: true, left: 24, isModel: true })));
const KeyboardConfig = ({ isVisible }) => (React.createElement(React.Fragment, null,
    React.createElement("div", { className: classnames(styles.settingMenu, { [styles.settingMenuWeb]: !systemApi.isElectron(), [styles.webWmEntry]: isWebWmEntry }), hidden: !isVisible },
        React.createElement("div", { className: styles.configTitle },
            React.createElement("div", { className: styles.configTitleName }, getIn18Text('KUAIJIEJIAN')),
            !isWebWmEntry && React.createElement("div", { onClick: () => navigate(-1), className: `dark-invert ${styles.configTitleIcon}` })),
        React.createElement("div", { className: styles.configContent },
            React.createElement("div", { className: styles.configContentWrap },
                React.createElement(Keyboard, null))))));
export default KeyboardConfig;
